// pages/ForgotPasswordPage.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Anchor, Button, Paper, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import CustomSnackbar from '../components/CustomSnackbar';
import classes from './LoginLogout.module.css';
import Environment from '../utility/environment';

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSendEmail = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const response = await fetch(`${Environment.VITE_API_URL}/api/v1/forgot_password/${email}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        setEmailSent(true);
      }

      if (response.ok) {
        const data = await response.json();
        if (data.message) {
          setEmailSent(true);
        }
      }

    } catch {
      console.error("ERRO INTERNO");
      setEmailSent(false);
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftContainer} style={{ position: 'relative' }}>
        <Paper component="form" className={classes.form} radius={0} p={30} onSubmit={handleSendEmail}>
          <img src="/images/icon_h.png" alt="Logo" className={classes.logo} />
          {!emailSent && (
            <>
              <TextInput
                label={t('auth.forgotPassword.email')}
                placeholder={t('auth.forgotPassword.emailPlaceholder')}
                size="md"
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
                className={classes.textInput}
              />
              <Button
                type="submit"
                fullWidth
                size="md"
                mt="xl"
                className={classes.customButton}
              >
                {t('common.send')}
              </Button>
            </>
          )}

          <Anchor<'a'>
            href="#"
            onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
              event.preventDefault();
              navigate('/login');
            }}
            className={classes.customAnchor}
            style={{ marginTop: 15, display: 'block', textAlign: 'center' }}
          >
            {t('auth.backToLogin')}
          </Anchor>
        </Paper>
        {/* Snackbar exibido quando o e-mail é enviado com sucesso */}
        <CustomSnackbar
          opened={emailSent}
          message={t('auth.forgotPassword.emailSent')}
          duration={2000}
          backgroundColor="green"
          onClose={() => navigate('/login')}
        />
      </div>

      <div className={classes.divider} />

      <div className={classes.rightContainer} />
    </div>
  );
};

export default ForgotPasswordPage;
